import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GET_CARD_SUMMARY, GET_DASHBOARD_CONFIGURATION } from '../../../../../../../store/actions';
import { Container, Row } from 'reactstrap';
import BreadcrumbTrail from '../../../../../../Common/BreadcrumbTrail';
import OverViewCard from './Components/OverViewCard';
import { Loader } from '../../../../../../Common';
import { useHistory } from 'react-router-dom';
import QuickLinkCard from './Components/QuickLinkCard';
import ShowPolygons from './Components/Polygon';

interface RootState {
  GetDashboardConfiguration?: {
    data?: any;
    loading?: boolean;
  };
  GetCardSummary?: {
    data?: any;
    loading?: boolean;
  };
}

const InventoryDashboard = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [loading, setLoading] = useState(false);
  const [inventoryCard, setInventoryCard] = useState([]);

  const { getDashboardConfiguration, getDashboardConfigurationLoading } = useSelector((state: RootState) => ({
    getDashboardConfiguration: state.GetDashboardConfiguration.data,
    getDashboardConfigurationLoading: state.GetDashboardConfiguration.loading,
  }));

  const { cardData, cardDataLoading } = useSelector((state: RootState) => ({
    cardData: state.GetCardSummary.data,
    cardDataLoading: state.GetCardSummary.loading,
  }));

  useEffect(() => {
    if (getDashboardConfiguration !== null) {
      const filterInventoryCard = getDashboardConfiguration?.modules?.inventory_airport_transfer_dashboard?.sections?.[0]?.cards;

      dispatch({
        type: GET_CARD_SUMMARY,
        payload: { cards: filterInventoryCard },
      });

      setInventoryCard(filterInventoryCard ?? []);
    } else {
      dispatch({
        type: GET_DASHBOARD_CONFIGURATION,
      });
    }
  }, [getDashboardConfiguration]);

  useEffect(() => {
    getDashboardData();
  }, []);

  useEffect(() => {
    if (getDashboardConfigurationLoading || cardDataLoading) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [getDashboardConfigurationLoading, cardDataLoading]);

  const getDashboardData = () => {
    dispatch({
      type: GET_DASHBOARD_CONFIGURATION,
    });
  };

  /* ---------------------------- BREADCRUM HANDLER ---------------------------- */
  const breadcrumNavigationHandler = title => {
    if (title === `Overview`) {
      history.push(`/v2/inventory-overview`);
    }
  };

  return (
    <div className="page-content">
      <Container fluid className="position-relative">
        {loading && <Loader />}
        <div className="bredcumb-responsive">
          <BreadcrumbTrail
            title={'Pricing Master Overview'}
            navigationby={breadcrumNavigationHandler}
            navigation={['Management', 'Inventory', 'Overview', 'Airport Transfer']}
          />
        </div>

        {inventoryCard && (
          <div className="approval-scroll-wrapper px-1 pb-5">
            <Row className="flex-wrap g-3">
              {inventoryCard?.map((item, index) => (
                <OverViewCard key={index} item={item} cardData={cardData} />
              ))}
            </Row>
          </div>
        )}

        <Row>
          <QuickLinkCard />
          <ShowPolygons />
        </Row>
      </Container>
    </div>
  );
};

export default InventoryDashboard;
